import { clsx } from 'clsx'
import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import { IconSprites } from '@constants/enums/sprites'

import { Icon } from '@components/ui-core/icon/icon'
import { Link } from '@components/ui-core/link/link'
import { type NavLinkItem } from '@components/ui-core/types'

import styles from './nav-links.module.scss'

type NavLinkProps = NavLinkItem & ComponentPropsWithoutRef<'a'>

export function NavLink(props: NavLinkProps): ReactElement {
  const { className, href, label, openIn, icon, ...rest } = props

  return (
    <Link href={href} className={clsx(styles.navLink, className)} {...rest}>
      {icon && <Icon className={styles.navLinkBeforeIcon} variant={icon} aria-hidden />}
      {label}
      {openIn === 'newTab' && <Icon variant={IconSprites.OpenNew} />}
    </Link>
  )
}
